import { formatDateWithDots } from "@pharmupp/p3-front-commons"
import type {
  ApiNotification,
  ApiNotificationType,
  AppNotification,
} from "./notification.model"

export const formatMyNotification = (notifications: ApiNotification[]) =>
  notifications.map<AppNotification>((notification) => ({
    ...notification,
    title: getTitleFromType(notification.type),
    criticality:
      notification.domain === "MARKETING_OPERATION" &&
      notification.type === "RESEND_PROOF_DOCUMENT"
        ? "HIGH"
        : "MEDIUM",
    deadline: formatDateWithDots(notification.deadline),
    link: getLink({ domain: notification.domain, entityId: notification.entityId }),
    linkText: getLinkText({ domain: notification.domain, type: notification.type }),
  }))

const getTitleFromType = (type: ApiNotificationType) => {
  switch (type) {
    case "REGISTER":
      return "S'inscrire"
    case "SEND_PROOF_DOCUMENT":
      return "Opé. marketing à justifier"
    case "RESEND_PROOF_DOCUMENT":
      return "Nouveau justificatif à fournir"
    case "SIGN_DOCUMENT":
      return "Document à signer"
  }
}

const getLinkText = ({ domain, type }: Pick<AppNotification, "domain" | "type">) => {
  switch (domain) {
    case "MARKETING_OPERATION":
      switch (type) {
        case "REGISTER":
          return "S'inscrire"
        case "SEND_PROOF_DOCUMENT":
        case "RESEND_PROOF_DOCUMENT":
          return "Justifier"
        default:
          return null
      }
    case "E_SIGNATURE":
      switch (type) {
        default:
          return "Signer"
      }

    default:
      return "Voir"
  }
}

const getLink = ({
  domain,
  entityId,
}: Pick<AppNotification, "domain" | "entityId">) => {
  switch (domain) {
    case "MARKETING_OPERATION":
      return `/operations/liste/${entityId}`
    default:
      return null
  }
}
